import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {View} from '../../custom-packages/react-native-components-in-react/react-native-components-in-react';
import * as AuthActions from "../../store/actions/authActions";
import {GetAuthObject} from "../../authentication/AuthFunctions";

const PreparingScreen = (props) => {
    //fetch Auth from redux
    const dispatch = useDispatch();
    const Auth = useSelector(state => state.Auth);
    const navigate = useNavigate();

    //Get a parameter from the route
    const params = new URLSearchParams(window.location.search);
    const returnUrl = params.get('returnUrl');

    useEffect(() => {
        const f = () => {
            const storedAuth = GetAuthObject();

            dispatch(AuthActions.saveAuth(storedAuth));

            setTimeout(() => {
                const businessID = localStorage.getItem("businessID");
                const role = localStorage.getItem("role");

                if (role == 'Bow' && !businessID) {
                    navigate('/admin/setup', { replace: true });
                } else if (returnUrl) {
                    navigate(returnUrl, { replace: true });
                } else {
                    navigate('/admin/food', { replace: true });
                }
            }, 200)
        }

        f();
    }, [])

    return (
        <View style={{ paddingTop: 200 }}>

        </View>
    );
};

export default PreparingScreen;